<div class="header">
  <div class="title">
    <h3>Notificaciones</h3>
  </div>
  <div class="show-read">
    <p>Mostrar solo las no leidas</p>
  </div>
  <div>
    <mat-slide-toggle
      (change)="getData($event)"
      class="custom-toggle"
    ></mat-slide-toggle>
  </div>
  <div class="all">
    <mat-icon matTooltip="Ver todas" (click)="showAll()">open_in_new</mat-icon>
  </div>
</div>
<div class="divisor"></div>
